var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLikeOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vote") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16615 5.83333H10.9451C11.8124 5.83333 12.3765 6.74603 11.9886 7.52175L9.94694 11.6051C9.74932 12.0003 9.34534 12.25 8.90344 12.25H6.55977C6.46438 12.25 6.36936 12.2383 6.27681 12.2152L4.08282 11.6667M8.16615 5.83333V2.91667C8.16615 2.27233 7.64381 1.75 6.99948 1.75H6.94379C6.65238 1.75 6.41615 1.98623 6.41615 2.27764C6.41615 2.69432 6.29281 3.10167 6.06168 3.44837L4.08282 6.41667V11.6667M8.16615 5.83333H6.99948M4.08282 11.6667H2.91615C2.27182 11.6667 1.74948 11.1443 1.74948 10.5V7C1.74948 6.35567 2.27182 5.83333 2.91615 5.83333H4.37448",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLikeOutline);
export default __webpack_public_path__ + "static/media/icon-like-outline.b589dab21361940335aa7c08c2b5227d.svg";
export { ForwardRef as ReactComponent };